export default __webpack_public_path__ + "static/media/footer-gallery-4.5ce00ac1.jpg";